import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setSessionExpireHandler } from "../utils/const";

const SessionExpiryModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messageText, setMessageText] = useState("Your session has expired.");
  const [subMessageText, setSubMessageText] = useState("You will be redirected to the login page.");
  const navigate = useNavigate();

  useEffect(() => {
    // Register a global handler to open this modal with an optional message
    const handler = (message) => {
      if (message) {
        setMessageText(message);
      }
      setIsOpen(true);
    };
    setSessionExpireHandler(handler);
    return () => setSessionExpireHandler(null);
  }, []);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1.5rem",
        backgroundColor: "rgba(15, 23, 42, 0.6)",
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          maxWidth: 620,
          borderRadius: 20,
          backgroundColor: "#fff",
          boxShadow: "0 20px 35px rgba(15, 23, 42, 0.25)",
          border: "1px solid rgba(148, 163, 184, 0.4)",
          padding: "32px 40px",
          textAlign: "center",
        }}
      >
        <img
          src="/assets/images/expire.png"
          alt="Session expired illustration"
          style={{ width: 200, height: 150, objectFit: "contain", margin: "0 auto" }}
        />
        <h2
          style={{
            marginTop: 24,
          fontSize: 24,
            fontWeight: 700,
            color: "#0f172a",
          }}
        >
          {messageText}
        </h2>
        <p
          style={{
            marginTop: 16,
            fontSize: 18,
            color: "#1f2937",
            fontWeight: 500,
          }}
        >
          {subMessageText}
        </p>

        <button
          style={{
            marginTop: 28,
            padding: "10px 32px",
            borderRadius: 9999,
            border: "none",
            background: "linear-gradient(135deg, #4B2C3B 0%, #6b3f55 100%)",
            color: "#fff",
            fontSize: 15,
            fontWeight: 600,
            cursor: "pointer",
          }}
          onClick={() => {
            try {
              localStorage.removeItem("api-token");
              localStorage.removeItem("adminId");
              localStorage.removeItem("adminName");
              localStorage.removeItem("phone");
              localStorage.removeItem("role");
              localStorage.removeItem("user_ip");
              localStorage.removeItem("token");
            } catch {}
            setIsOpen(false);
            navigate("/login", { replace: true });
          }}
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default SessionExpiryModal;


